import { AlertTriangle, CheckCircle, XCircle, Info, LucideIcon } from "lucide-react";

interface AlertProps {
    title?: string;
    description: string | React.ReactNode;
    type: "success" | "error" | "warning" | "info";
    icon?: LucideIcon;
    className?: string;
}

export const Alert = ({ title, description, type, icon: CustomIcon, className = "" }: AlertProps) => {
    const styles = {
        success: {
            bg: "bg-green-50",
            border: "border-green-200",
            icon: "text-green-600",
            title: "text-green-800",
            text: "text-green-700",
            Icon: CheckCircle
        },
        error: {
            bg: "bg-red-50",
            border: "border-red-200",
            icon: "text-red-600",
            title: "text-red-800",
            text: "text-red-700",
            Icon: XCircle
        },
        warning: {
            bg: "bg-amber-50",
            border: "border-amber-300",
            icon: "text-amber-600",
            title: "text-amber-800",
            text: "text-amber-700",
            Icon: AlertTriangle
        },
        info: {
            bg: "bg-blue-50",
            border: "border-blue-200",
            icon: "text-blue-600",
            title: "text-blue-800",
            text: "text-blue-700",
            Icon: Info
        }
    };

    const style = styles[type];
    const IconComponent = CustomIcon || style.Icon;

    return (
        <div className={`flex items-start gap-2 p-4 rounded-xl border-2 ${style.bg} ${style.border} ${className}`}>
            <IconComponent className={`w-6 h-6 flex-shrink-0 mt-0.5 ${style.icon}`} />
            <div className="flex flex-col gap-1">
                {title && <h3 className={`text-base font-semibold ${style.title}`}>{title}</h3>}
                <p className={`text-sm ${style.text}`}>{description}</p>
            </div>
        </div>
    )
}